import {
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  word-wrap: break-word;
`;

export const QuestionLabel = styled.p`
  margin-bottom: 10px;
`;

export const Instructions = styled.div`
  margin-top: 18px;
`;

export const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin: 0 0 1em;
  }
`;
